import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_licenseplate_by_lookupcode_warehouse_archivedService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseId: number, lookupcode: string, archived: boolean }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil(inParams.archived)) {
      missingRequiredInParams.push('\'archived\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseId: number, lookupcode: string, archived: boolean, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil(inParams.archived)) {
      missingRequiredInParams.push('\'archived\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseId: number, lookupcode: string, archived: boolean, $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil(inParams.archived)) {
      missingRequiredInParams.push('\'archived\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseId: number, lookupcode: string, archived: boolean    }) {
        if(isNil(inParams.warehouseId)) {
          return true; 
        }
        if(isNil(inParams.lookupcode)) {
          return true; 
        }
        if(isNil(inParams.archived)) {
          return true; 
        }
      return false;
    }
}
